/**
 * Short labels and tooltips for the woven pieces (docs/spells-depth.md): the
 * two-letter chip label and "Obsidian (Lava + Ice, woven)". Pure, so the
 * HUD, the book and the tests share it.
 */

import type { WovenElement } from '@shared/index.js';
import { WOVEN_INFO, WOVEN_LIST, elementName, recipeOf } from '@shared/index.js';

export const WOVEN_SHORT: Readonly<Record<WovenElement, string>> = Object.fromEntries(
  WOVEN_LIST.map((el) => [el, WOVEN_INFO[el].short]),
) as Record<WovenElement, string>;

/** "Obsidian (Lava + Ice, woven)". */
export function wovenTitle(el: WovenElement): string {
  const r = recipeOf(el);
  return r ? `${elementName(el)} (${elementName(r.a)} + ${elementName(r.b)}, woven)` : elementName(el);
}

export const WOVEN_TITLE: Readonly<Record<WovenElement, string>> = Object.fromEntries(
  WOVEN_LIST.map((el) => [el, wovenTitle(el)]),
) as Record<WovenElement, string>;
